import React from "react";

function Faq(props) {

  return (
    <>
      <div className="faqs">
        <h2>
          <span className="txt-gradient-1">Frequently Asked Questions</span>
        </h2>
        <div className="workshop_bodytext">
          Here are some answers to some common questions - use the filters/search to narrow things down. If you can't find an answer here, <a href="/contact">drop us a line</a>.
        </div>
        <div
          className="accordion faq-accordion accordion-flush"
          id="faq-accordion-example"
        >

          {props.faqs.map((w) => (

          <div className="accordion-item faq-accordion" key={w.id}>
            <div className="accordion-header" id={`faq-heading${w.id}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#faq-collapse${w.id}`}
                aria-expanded="false"
                aria-controls={`faq-collapse${w.id}`}
              >
                {w.question}
              </button>
            </div>
            <div
              id={`faq-collapse${w.id}`}
              className="accordion-collapse collapse"
              aria-labelledby={`faq-heading${w.id}`}
              data-bs-parent="#faq-accordion-example"
            >
              <div className="accordion-body">
                <p>
                {w.answer}
                </p>
              </div>
            </div>
          </div>

          ))}

        </div>
      </div>
    </>
  );
}

export default Faq;
